<administrasjon-navigasjon aktiv="avtaler">
<div class="administrasjon-avtaler-side">
    @for (avtale of avtaler(); track avtale.id) {
      <administrasjon-avtale [avtale]="avtale" (avtaleOppdatert)="vedAvtaleOppdatert($event)"/>
    }
</div>
</administrasjon-navigasjon>
